<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo"
                   :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'sqr'" v-model="formData.sqr" :required="isRequired('sqr')" name="flowName" label="申请人"
                   placeholder="申请人" input-align="right" :rules="getRules('sqr')">
          <template #input>
            <view-item :value="formData.sqr" placeholder="请选择申请人"/>
          </template>
        </van-field>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <!--        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')" :value="formData.ssxm" :rules="getRules('ssxm')" label="所属项目" placeholder="请选择项目">-->
        <!--          <template #input>-->
        <!--            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm" placeholder="请选择项目"/>-->
        <!--            &lt;!&ndash;            {{formData.ssxm}}&ndash;&gt;-->
        <!--            <van-popup v-model="ssxm.show" position="bottom">-->
        <!--              <van-nav-bar title="选择项目" left-text="取消" right-text="确定" @click-left="ssxm.show = false" @click-right="popupSubmitSsxm('ssxm',{label:'projectName',value:'projectId'})"/>-->
        <!--              <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'projectName')" clearable shape="round"/>-->
        <!--              <van-picker :duration="0" ref="ssxm" value-key="projectName" :columns="ssxm.filteredData" @cancel="ssxm.show = false"/>-->
        <!--            </van-popup>-->
        <!--          </template>-->
        <!--        </van-field>-->

        <van-field v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')"
                   :value="formData.ssxm" :rules="getRules('ssxm')" label="关联业务" placeholder="请选择项目/合同">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm.split(',')[1]"
                       placeholder="请选择项目/合同"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目/合同" left-text="取消" right-text="确定" @click-left="ssxm.show = false"
                           @click-right="businessSelectFinish('ssxm')"/>
              <van-row type="flex" align="center" class="p-r-20">
                <van-col :span="18">
                  <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'name','columnsLabel')" clearable
                              shape="round"/>
                </van-col>
                <van-col :span="6">
                  <van-button :loading="btnLoading" @click="selectMyProjectList('',true)" loading-text="加载中..."
                              type="primary" native-type="button" size="small">更多项目...
                  </van-button>
                </van-col>
              </van-row>
              <van-picker :duration="0" ref="ssxm" value-key="columnsLabel" :columns="ssxm.filteredData" @change="onChange"
                          @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'ssxm'" v-model="deptcost" label="成本归属部门" input-align="right" readonly/>

        <van-field v-f-show="'bxsy'" v-model="formData.bxsy" :disabled="isDisabled('bxsy')"
                   :required="isRequired('bxsy')" name="bxsy" :rules="getRules('bxsy')" type="textarea" maxlength="200"
                   rows="3" autosize label="报销事由" show-word-limit placeholder="请输入报销事由" input-align="right"/>
        <van-field v-f-show="'skrfkbz'" v-model="formData.skrfkbz" :disabled="isDisabled('skrfkbz')"
                   :required="isRequired('skrfkbz')" :rules="getRules('skrfkbz')" name="skrfkbz" type="textarea"
                   maxlength="200" rows="3" autosize label="付款备注" show-word-limit
                   placeholder="请在填写付款备注时，避免使用 “福利、劳务费、工资、薪贴、奖金” 等相关表述。"
                   input-align="right"/>
        <van-field v-f-show="'skrbz'" v-model="formData.skrbz" :disabled="isDisabled('skrbz')"
                   :required="isRequired('skrbz')" :rules="getRules('skrbz')" name="skrbz" type="textarea"
                   maxlength="200" rows="3" autosize label="备注" show-word-limit placeholder="请输入备注"
                   input-align="right"/>
        <!--        <van-field v-f-show="'bxfs'" v-model="formData.bxfs" center input-align="right" :required="isRequired('bxfs')" name="bxfs" :rules="getRules('bxfs')" label="是否使用备用金报销" placeholder="是否使用备用金报销">~-->
        <!--          <template #input>-->
        <!--            <view-item v-if="isDisabled('bxfs')" :value="formData.bxfs == '0' ? '否' : '是'" placeholder="请选择申请人"/>-->
        <!--            <van-radio-group v-else v-model="formData.bxfs" direction="horizontal">-->
        <!--              <van-radio name="0">否</van-radio>-->
        <!--              <van-radio name="1">是</van-radio>-->
        <!--            </van-radio-group>-->
        <!--          </template>-->
        <!--        </van-field>-->


        <van-field v-f-show="'zmlx'" input-align="right" name="zmlx" :required="isRequired('zmlx')"
                   :rules="getRules('zmlx')" label="账套类型" placeholder="请选择账套类型">
          <template #input>
            <view-item v-if="isDisabled('zmlx')" :showLabel="formData.zmlx"/>
            <van-checkbox-group v-else v-model="formData.zmlx" style="display: flex;">
              <van-checkbox name="管理账套" style="margin-right: 10px;">管理账套</van-checkbox>
              <van-checkbox name="核算账套">核算账套</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field v-f-show="'hsgs'" input-align="right" name="hsgs" :required="isRequired('hsgs')"
                   :value="formData.hsgs" :rules="getRules('hsgs')" label="所属核算公司" placeholder="请选择核算公司">
          <template #input>
            <view-item @click.native="isShowPopup(hsgs,'hsgs')" :value="formData.hsgs" placeholder="请选择核算公司"/>
            <van-popup v-model="hsgs.show" position="bottom">
              <van-nav-bar title="选择核算公司" left-text="取消" right-text="确定" @click-left="hsgs.show = false"
                           @click-right="popupSubmit('hsgs',{label:'name',value:'id'})"/>
              <van-search v-model="hsgs.filterText" @input="pickerSearch($event,hsgs,'name')" clearable shape="round"/>
              <van-picker :duration="0" ref="hsgs" value-key="name" :columns="hsgs.filteredData"
                          @cancel="hsgs.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'startFlowDate'" v-model="formData.startFlowDate" :required="isRequired('startFlowDate')"
                   name="startFlowDate" label="报销日期"
                   placeholder="报销日期" input-align="right" :rules="getRules('startFlowDate')">
          <template #input>
            <view-item @click.native="isShowPopup(startFlowDate,'startFlowDate')" :value="formData.startFlowDate"
                       placeholder="请选择报销日期"/>
            <van-calendar v-model="startFlowDate.show" ref="startFlowDate" :min-date="startFlowDate.minDate"
                          :max-date="startFlowDate.maxDate" :show-confirm="false" title="选择报销日期"
                          @confirm="startFlowDateConfirm"></van-calendar>
          </template>
        </van-field>
      </van-cell-group>


      <div v-f-show="'jdzsfymxb'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">酒店住宿费用</div>
        <van-cell-group v-for="(item,index) in formData.jdzsfymxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `酒店住宿费用明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('jdzsfymxb')" @click="removeItem(index,'jdzsfymxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>

          <van-field v-f-show="'cccs'" v-model="item.cccs" name="cccs" :required="isRequired('cccs')"
                     :rules="getRules('cccs')" label="出差城市" placeholder="出差城市" input-align="right">
            <template #input>
              <view-item @click.native="popupShow(cccs.show,index,'cccs')" :value="item.cccs"
                         placeholder="请选择出差城市"/>
              <van-popup position="bottom" v-model="cccs.show[index]">
                <van-nav-bar title="选择出差城市" left-text="取消" right-text="确定"
                             @click-left="popupHidden(cccs.show,index)" @click-right="cccsPopupSubmit(item,index)"/>
                <van-search v-model="cccs.filterText[index]" @input="treeSearch($event,$refs[`cccsTree_${index}`])"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`cccsTree_${index}`"
                             @check-change="singleChoice($event,$refs[`cccsTree_${index}`],index)" node-key="id"
                             check-strictly :data="cccs.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'sfhz'" input-align="right" name="sfhz" :rules="getRules('sfhz')"
                     :required="isRequired('sfhz')" :value="item.sfhz" label="是否合住" placeholder="请选择是否合住">
            <template #input>
              <view-item @click.native="popupShow(sfhz.show,index,'sfhz')" :value="item.sfhz"
                         placeholder="请选择是否合住"/>
              <van-popup v-model="sfhz.show[index]" position="bottom">
                <van-nav-bar title="选择是否合住" left-text="取消" right-text="确定"
                             @click-left="popupHidden(sfhz.show,index)" @click-right="sfhzSubmit(item,index)"/>
                <van-search v-model="sfhz.filterText" @input="pickerSearch($event,sfhz)" clearable shape="round"/>
                <van-picker :ref="`sfhzPicker_${index}`" value-key="name" :columns="sfhz.filteredData"
                            @cancel="sfhz.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'rzrq'" v-model="item.rzrq" :required="isRequired('rzrq')" name="rzrq" label="入住日期"
                     placeholder="入住日期" input-align="right" :rules="getRules('rzrq')">
            <template #input>
              <view-item @click.native="popupShow(rzrq.show,index,'rzrq')" :value="item.rzrq"
                         placeholder="请选择入住日期"/>
              <van-calendar :min-date="ccsj.minDate" v-model="rzrq.show[index]" ref="rzrq" :show-confirm="false"
                            title="选择入住日期" @confirm="(date) => {rzrqConfirm(date,item,index)}"></van-calendar>
            </template>
          </van-field>
          <van-field v-f-show="'ldrq'" v-model="item.ldrq" :required="isRequired('ldrq')" name="ldrq" label="离店日期"
                     placeholder="离店日期" input-align="right" :rules="getRules('ldrq')">
            <template #input>
              <view-item @click.native="popupShow(ldrq.show,index,'ldrq')" :value="item.ldrq"
                         placeholder="请选择离店日期"/>
              <van-calendar :min-date="ccsj.minDate" v-model="ldrq.show[index]" ref="ldrq" :show-confirm="false"
                            title="选择离店日期" @confirm="(date) => {ldrqConfirm(date,item,index)}"></van-calendar>
            </template>
          </van-field>
          <van-field v-f-show="'zsts'" :disabled="isDisabled('zsts')" v-model="item.zsts" type="number" name="zsts"
                     :rules="getRules('zsts')" :required="isRequired('zsts')" :maxlength="8" placeholder="请输入天数"
                     label="天数" input-align="right"></van-field>
          <van-field v-f-show="'bxje'" :disabled="isDisabled('bxje')" v-model="item.bxje" type="number" name="bxje"
                     :rules="getRules('bxje')" :required="isRequired('bxje')" :maxlength="10"
                     placeholder="请输入费用金额" label="费用金额" @change="formatToTwoDecimals(item, 'bxje')"
                     input-align="right"></van-field>
          <van-field v-f-show="'fymx'" :disabled="isDisabled('fymx')" v-model="item.fymx" type="textarea" name="fymx"
                     :rules="getRules('fymx')" :required="isRequired('fymx')" maxlength="200" rows="3" autosize
                     label="费用说明" show-word-limit placeholder="请输入费用说明" input-align="right"/>
          <van-field v-f-show="'gskm'" :value="item.gskm" input-align="right" name="gskm" :rules="getRules('gskm')"
                     :required="isRequired('gskm')" label="归属科目" placeholder="请选择归属科目">
            <template #input>
              <view-item @click.native="popupShow(gskm.show,index,'gskm')" :value="item.gskm"
                         placeholder="请选择归属科目"/>
              <van-popup v-model="gskm.show[index]" position="bottom">
                <van-nav-bar title="选择归属科目" left-text="取消" right-text="确定"
                             @click-left="popupHidden(gskm.show,index)" @click-right="gskmSubmit(item,index)"/>
                <van-search v-model="gskm.filterText" @input="treeSearch($event,$refs[`gskmTree_${index}`])" clearable
                            shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`gskmTree_${index}`"
                             @check-change="singleChoice($event,$refs[`gskmTree_${index}`],index)" node-key="id"
                             check-strictly :data="gskm.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-f-show="'jdzsfhj'" class="m-t-20">
          <van-field v-f-show="'jdzsfhj'" center v-model="formData.jdzsfhj" :rules="getRules('jdzsfhj')"
                     :required="isRequired('jdzsfhj')" label="住宿费合计" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.jdzsfhj)+' 元'"
                      v-if="formData.jdzsfhj && formData.jdzsfhj!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.jdzsfhj && formData.jdzsfhj!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.jdzsfhj) }}</span>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <van-row v-if="!isDisabled('jdzsfymxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加费用明细" @click="addJdItem"
                        class="width-100"/>
          </van-col>
        </van-row>
      </div>
      <div v-f-show="'cjjtfymxb'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">城际交通费用</div>
        <van-cell-group v-for="(item,index) in formData.cjjtfymxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `城际交通费用明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('cjjtfymxb')" @click="removeItem(index,'cjjtfymxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>
          <van-field v-f-show="'xch'" :disabled="isDisabled('xch')" v-model="item.xch" name="xch"
                     :rules="getRules('xch')" :required="isRequired('xch')" :maxlength="50" placeholder="请输入行程号"
                     label="行程号" input-align="right"></van-field>
          <van-field v-f-show="'cfsj'" v-model="item.cfsj" :required="isRequired('cfsj')" name="cfsj" label="出发时间"
                     placeholder="出发时间" input-align="right" :rules="getRules('cfsj')">
            <template #input>
              <view-item @click.native="popupShow(cfsj.show,index,'cfsj')" :value="item.cfsj"
                         placeholder="请选择出发时间"/>
              <van-calendar :min-date="ccsj.minDate" v-model="cfsj.show[index]" ref="cfsj" :show-confirm="false"
                            title="选择出发时间" @confirm="(date) => {cfsjConfirm(date,item,index)}"></van-calendar>
            </template>
          </van-field>
          <van-field v-f-show="'cfcs'" v-model="item.cfcs" name="cfcs" :required="isRequired('cfcs')"
                     :rules="getRules('cfcs')" label="出发城市" placeholder="出发城市" input-align="right">
            <template #input>
              <view-item @click.native="popupShow(cfcs.show,index,'cfcs')" :value="item.cfcs"
                         placeholder="请选择出发城市"/>
              <van-popup position="bottom" v-model="cfcs.show[index]">
                <van-nav-bar title="选择出发城市" left-text="取消" right-text="确定"
                             @click-left="popupHidden(cfcs.show,index)" @click-right="cfcsPopupSubmit(item,index)"/>
                <van-search v-model="cfcs.filterText[index]" @input="treeSearch($event,$refs[`cfcsTree_${index}`])"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`cfcsTree_${index}`"
                             @check-change="singleChoice($event,$refs[`cfcsTree_${index}`],index)" node-key="id"
                             check-strictly :data="cfcs.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'ddcs'" v-model="item.ddcs" name="ddcs" :required="isRequired('ddcs')"
                     :rules="getRules('ddcs')" label="到达城市" placeholder="到达城市" input-align="right">
            <template #input>
              <view-item @click.native="popupShow(ddcs.show,index,'ddcs')" :value="item.ddcs"
                         placeholder="请选择到达城市"/>
              <van-popup position="bottom" v-model="ddcs.show[index]">
                <van-nav-bar title="选择到达城市" left-text="取消" right-text="确定"
                             @click-left="popupHidden(ddcs.show,index)" @click-right="ddcsPopupSubmit(item,index)"/>
                <van-search v-model="ddcs.filterText[index]" @input="treeSearch($event,$refs[`ddcsTree_${index}`])"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`ddcsTree_${index}`"
                             @check-change="singleChoice($event,$refs[`ddcsTree_${index}`],index)" node-key="id"
                             check-strictly :data="ddcs.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'jtgj'" input-align="right" name="jtgj" :rules="getRules('jtgj')"
                     :required="isRequired('jtgj')" :value="item.jtgj" label="交通工具" placeholder="请选择交通工具">
            <template #input>
              <view-item @click.native="popupShow(jtgj.show,index,'jtgj')" :value="item.jtgj"
                         placeholder="请选择交通工具"/>
              <van-popup v-model="jtgj.show[index]" position="bottom">
                <van-nav-bar title="选择交通工具" left-text="取消" right-text="确定"
                             @click-left="popupHidden(jtgj.show,index)" @click-right="jtgjSubmit(item,index)"/>
                <van-search v-model="jtgj.filterText" @input="pickerSearch($event,jtgj)" clearable shape="round"/>
                <van-picker :ref="`jtgjPicker_${index}`" value-key="name" :columns="jtgj.filteredData"
                            @cancel="jtgj.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'jtlksj'" v-model="item.jtlksj" :required="isRequired('jtlksj')" name="jtlksj"
                     label="离开时间" placeholder="离开时间" input-align="right" :rules="getRules('jtlksj')">
            <template #input>
              <view-item @click.native="popupShow(jtlksj.show,index,'jtlksj')" :value="item.jtlksj"
                         placeholder="请选择离开时间"/>
              <van-calendar v-model="jtlksj.show[index]" :min-date="ccsj.minDate" ref="jtlksj" :show-confirm="false"
                            title="选择离开时间" @confirm="(date) => {jtlksjConfirm(date,item,index)}"></van-calendar>
            </template>
          </van-field>
          <van-field v-f-show="'jtfyje'" :disabled="isDisabled('jtfyje')" v-model="item.jtfyje" type="number"
                     name="jtfyje" :rules="getRules('jtfyje')" :required="isRequired('jtfyje')" :maxlength="10"
                     placeholder="请输入费用金额" label="费用金额" input-align="right"
                     @change="formatToTwoDecimals(item, 'jtfyje')"></van-field>
          <van-field v-f-show="'jtfysm'" :disabled="isDisabled('jtfysm')" v-model="item.jtfysm" type="textarea"
                     name="jtfysm" :rules="getRules('jtfysm')" :required="isRequired('jtfysm')" maxlength="200" rows="3"
                     autosize label="费用说明" show-word-limit placeholder="请输入费用说明" input-align="right"/>
          <van-field v-f-show="'jtfygskm'" :value="item.jtfygskm" input-align="right" name="jtfygskm"
                     :rules="getRules('jtfygskm')" :required="isRequired('jtfygskm')" label="归属科目"
                     placeholder="请选择归属科目">
            <template #input>
              <view-item @click.native="popupShow(jtfygskm.show,index,'jtfygskm')" :value="item.jtfygskm"
                         placeholder="请选择归属科目"/>
              <van-popup v-model="jtfygskm.show[index]" position="bottom">
                <van-nav-bar title="选择归属科目" left-text="取消" right-text="确定"
                             @click-left="popupHidden(jtfygskm.show,index)" @click-right="jtfygskmSubmit(item,index)"/>
                <van-search v-model="jtfygskm.filterText" @input="treeSearch($event,$refs[`jtfygskmTree_${index}`])"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`jtfygskmTree_${index}`"
                             @check-change="singleChoice($event,$refs[`jtfygskmTree_${index}`],index)" node-key="id"
                             check-strictly :data="jtfygskm.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-f-show="'cjjtfhj'" class="m-t-20">
          <van-field v-f-show="'cjjtfhj'" center v-model="formData.cjjtfhj" :rules="getRules('cjjtfhj')"
                     :required="isRequired('cjjtfhj')" label="交通费用合计" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.cjjtfhj)+' 元'"
                      v-if="formData.cjjtfhj && formData.cjjtfhj!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.cjjtfhj && formData.cjjtfhj!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.cjjtfhj) }}</span>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <van-row v-if="!isDisabled('cjjtfymxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加费用明细" @click="addcjjtItem"
                        class="width-100"/>
          </van-col>
        </van-row>
      </div>
      <div v-f-show="'qtfymxb'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">其他费用</div>
        <van-cell-group v-for="(item,index) in formData.qtfymxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `其他费用明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('qtfymxb')" @click="removeItem(index,'qtfymxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>
          <van-field v-f-show="'qtfylx'" v-model="item.qtfylx" name="qtfylx" :required="isRequired('qtfylx')"
                     :rules="getRules('qtfylx')" label="费用类型" placeholder="费用类型" input-align="right">
            <template #input>
              <view-item @click.native="popupShow(qtfylx.show,index,'qtfylx')" :value="item.qtfylx"
                         placeholder="请选择费用类型"/>
              <van-popup position="bottom" v-model="qtfylx.show[index]">
                <van-nav-bar title="选择费用类型" left-text="取消" right-text="确定"
                             @click-left="popupHidden(qtfylx.show,index)" @click-right="qtfylxPopupSubmit(item,index)"/>
                <van-search v-model="qtfylx.filterText[index]" @input="treeSearch($event,$refs[`qtfylxTree_${index}`])"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`qtfylxTree_${index}`"
                             @check-change="singleChoice($event,$refs[`qtfylxTree_${index}`],index)" node-key="id"
                             check-strictly :data="qtfylx.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'qtfyje'" :disabled="isDisabled('qtfyje')" v-model="item.qtfyje" type="number"
                     name="qtfyje" :rules="getRules('qtfyje')" :required="isRequired('qtfyje')" :maxlength="10"
                     placeholder="请输入费用金额" label="费用金额" input-align="right"
                     @change="formatToTwoDecimals(item, 'qtfyje')"></van-field>
          <van-field v-f-show="'qtfymx'" :disabled="isDisabled('qtfymx')" v-model="item.qtfymx" type="textarea"
                     name="qtfymx" :rules="getRules('qtfymx')" :required="isRequired('qtfymx')" maxlength="200" rows="3"
                     autosize label="费用说明" show-word-limit placeholder="请输入费用明细" input-align="right"/>
          <van-field v-f-show="'qtgskm'" :value="item.qtgskm" input-align="right" name="qtgskm"
                     :rules="getRules('qtgskm')" :required="isRequired('qtgskm')" label="归属科目"
                     placeholder="请选择归属科目">
            <template #input>
              <view-item @click.native="popupShow(qtgskm.show,index,'qtgskm')" :value="item.qtgskm"
                         placeholder="请选择归属科目"/>
              <van-popup v-model="qtgskm.show[index]" position="bottom">
                <van-nav-bar title="选择归属科目" left-text="取消" right-text="确定"
                             @click-left="popupHidden(qtgskm.show,index)" @click-right="qtgskmSubmit(item,index)"/>
                <van-search v-model="qtgskm.filterText" @input="treeSearch($event,$refs[`qtgskmTree_${index}`])"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`qtgskmTree_${index}`"
                             @check-change="singleChoice($event,$refs[`qtgskmTree_${index}`],index)" node-key="id"
                             check-strictly :data="qtgskm.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-f-show="'qtfyhj'" class="m-t-20">
          <van-field v-f-show="'qtfyhj'" center v-model="formData.qtfyhj" :rules="getRules('qtfyhj')"
                     :required="isRequired('qtfyhj')" label="其他费用合计" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.qtfyhj)+' 元'"
                      v-if="formData.qtfyhj && formData.qtfyhj!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.qtfyhj && formData.qtfyhj!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.qtfyhj) }}</span>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <van-row v-if="!isDisabled('qtfymxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加费用明细" @click="addQtfyItem"
                        class="width-100"/>
          </van-col>
        </van-row>
      </div>
      <div v-f-show="'clbzmxb'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">差旅补助</div>
        <van-cell-group v-for="(item,index) in formData.clbzmxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `差旅补助明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('clbzmxb')" @click="removeItem(index,'clbzmxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>
          <van-field v-f-show="'ccsj'" :value="item.ccsj[0]" :required="isRequired('ccsj')" name="ccsj" label="出差时间"
                     placeholder="出差时间" input-align="right" :rules="getRules('ccsj')">
            <template #input>
              <view-item v-if="isDisabled('ccsj')"
                         :value="item.ccsj.length > 1 ? `${item.ccsj[0]} - ${item.ccsj[1]}` : ''"
                         placeholder="请选择出差时间"/>
                         
              <view-item v-else @click.native="popupShow(ccsj.show,index,'ccsj')" :value="item.ccsj.length > 1 ? `${item.ccsj[0]} - ${item.ccsj[1]}` : ''"
                         placeholder="请选择出差时间"></view-item>
              <van-calendar v-model="ccsj.show[index]" :min-date="ccsj.minDate" allow-same-day ref="ccsj" type="range"
                            :show-confirm="false" title="选择出差时间"
                            @confirm="(date) => {ccsjConfirm(date,item,index)}"></van-calendar>
            </template>

          </van-field>
          <van-field v-f-show="'cbts'"  :disabled="isDisabled('cbts')"     v-model="item.cbts" type="number" name="cbts" :rules="getRules('cbts')"
                     :required="isRequired('cbts')" :maxlength="8" placeholder="请输入差补天数" label="差补天数"
                     input-align="right"></van-field>
          <van-field v-f-show="'cbbz'" @input="(value) => {cbbzFieldInput(value,item,index)}"
                     :disabled="isDisabled('cbbz')" v-model="item.cbbz" type="number" name="cbbz"
                     :rules="getRules('cbbz')" :required="isRequired('cbbz')" :maxlength="8"
                     placeholder="请输入差补标准" label="差补标准" input-align="right"></van-field>
          <van-field v-f-show="'cbje'" :disabled="isDisabled('cbje')" v-model="item.cbje" type="number" name="cbje"
                     :rules="getRules('cbje')" :required="isRequired('cbje')" :maxlength="10"
                     placeholder="请输入差补金额" label="差补金额" input-align="right"
                     @change="formatToTwoDecimals(item, 'cbje')"></van-field>
          <van-field v-f-show="'clgskm'" :value="item.clgskm" input-align="right" name="clgskm"
                     :rules="getRules('clgskm')" :required="isRequired('clgskm')" label="归属科目"
                     placeholder="请选择归属科目">
            <template #input>
              <view-item @click.native="popupShow(clgskm.show,index,'clgskm')" :value="item.clgskm"
                         placeholder="请选择归属科目"/>
              <van-popup v-model="clgskm.show[index]" position="bottom">
                <van-nav-bar title="选择归属科目" left-text="取消" right-text="确定"
                             @click-left="popupHidden(clgskm.show,index)" @click-right="clgskmSubmit(item,index)"/>
                <van-search v-model="clgskm.filterText" @input="treeSearch($event,$refs[`clgskmTree_${index}`])"
                            clearable shape="round"/>
                <div style="overflow-y: auto" class="h-vh-35">
                  <div class="p-10">
                    <el-tree :ref="`clgskmTree_${index}`"
                             @check-change="singleChoice($event,$refs[`clgskmTree_${index}`],index)" node-key="id"
                             check-strictly :data="clgskm.data" :filter-node-method="filterNode" check-on-click-node
                             show-checkbox/>
                  </div>
                </div>
              </van-popup>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-f-show="'clbzhj'" class="m-t-20">
          <van-field v-f-show="'clbzhj'" center v-model="formData.clbzhj" :rules="getRules('clbzhj')"
                     :required="isRequired('clbzhj')" label="差旅补助合计" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.clbzhj)+' 元'"
                      v-if="formData.clbzhj && formData.clbzhj!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.clbzhj && formData.clbzhj!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.clbzhj) }}</span>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <van-row v-if="!isDisabled('clbzmxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加差补明细" @click="addClbzItem"
                        class="width-100"/>
          </van-col>
        </van-row>
      </div>
      <div v-f-show="'bxzje'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">差旅费用合计</div>
        <van-cell-group class="b-r-10 m-t-20">
          <van-field v-f-show="'bxzje'" center v-model="formData.bxzje" :rules="getRules('bxzje')"
                     :required="isRequired('bxzje')" label="差旅费用合计" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.bxzje)+' 元'" v-if="formData.bxzje && formData.bxzje!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.bxzje && formData.bxzje!=0">
                  <span class="p-l-20">大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.bxzje) }}</span>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">借款冲销</div>
      <van-cell-group class="m-t-10">
        <van-field v-f-show="'bxfs'" v-model="formData.bxfs" center input-align="right" :required="isRequired('bxfs')"
                   name="bxfs" :rules="getRules('bxfs')" label="报销方式" placeholder="请选择报销方式">~
          <template #input>
            <view-item v-if="isDisabled('bxfs')"
                       :value="formData.bxfs == '0' ? '正常报销' : (formData.bxfs == '1' ? '借款冲销' : '供应商货款冲销')"
                       placeholder="请选择申请人"/>
            <van-radio-group v-else @change="changeBxfs()" v-model="formData.bxfs" direction="horizontal">
              <van-radio class="m-r-20" name="0">正常报销</van-radio>
              <van-radio class="m-r-20" name="1">借款冲销</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-f-show="'bxfs'" v-model="formData.debtMoney" :required="isRequired('debtMoney')"
                   label="累计借款欠款" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.debtMoney)+' 元'"
                    v-if="formData.debtMoney && formData.debtMoney!=0"></span>
              <span v-else>无</span>
              <span class="p-l-20" v-if="formData.debtMoney && formData.debtMoney!=0"> 大写：</span>
              <span class="cor-F64646"
                    v-if="formData.debtMoney && formData.debtMoney != 0">{{ getChinese(formData.debtMoney) }}</span>
            </div>
          </template>
        </van-field>
        <!-- <van-field v-f-show="'pjzs'" v-model="formData.pjzs" :disabled="isDisabled('pjzs')" type="number"
                   :required="isRequired('pjzs')" :rules="getRules('pjzs')" name="pjzs" maxlength="50" autosize
                   label="票据张数" placeholder="请输入票据张数" input-align="right"/> -->
      </van-cell-group>
      <div v-if="formData.bxfs=='1'">
        <van-cell-group v-for="(item,index) in formData.byjmxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `借款明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('byjmxb')" @click="removeItem(index,'byjmxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>
          <van-field v-f-show="'userName'" :required="isRequired('userName')" v-model="item.userName"
                     :rules="getRules('userName')" label="借款人" input-align="right" readonly/>
          <van-field v-f-show="'businessNo'" :required="isRequired('businessNo')" v-model="item.businessNo"
                     :rules="getRules('businessNo')" label="关联单号" input-align="right" readonly/>
          <van-field v-f-show="'debtTime'" :required="isRequired('debtTime')" v-model="item.debtTime"
                     :rules="getRules('debtTime')" label="借款时间" input-align="right" readonly>
            <template #input>
              {{ moment(item.debtTime).format('YYYY-MM-DD hh:mm:ss') }}
            </template>
          </van-field>
          <van-field v-f-show="'debtAmount'" :required="isRequired('debtAmount')" v-model="item.debtAmount"
                     :rules="getRules('debtAmount')" label="借款金额" @change="formatToTwoDecimals(item, 'debtAmount')"
                     input-align="right" readonly/>
          <van-field v-f-show="'repayAmount'" :required="isRequired('repayAmount')" v-model="item.repayAmount"
                     :rules="getRules('repayAmount')" label="已还款金额" input-align="right" readonly
                     @change="formatToTwoDecimals(item, 'repayAmount')"/>
          <van-field v-f-show="'currentRepayAmount'" :disabled="isDisabled('currentRepayAmount')"
                     v-model="item.currentRepayAmount" type="number" name="currentRepayAmount"
                     :rules="getRules('currentRepayAmount')" :required="isRequired('currentRepayAmount')"
                     :maxlength="10"
                     placeholder="请输入本次冲销金额" label="本次冲销金额" input-align="right"
                     @change="formatToTwoDecimals(item, 'currentRepayAmount')"></van-field>
          <!--          <van-field v-f-show="'payCash'" :disabled="isDisabled('payCash')" v-model="item.payCash" type="number"-->
          <!--                     name="payCash" :rules="getRules('payCash')" :required="isRequired('payCash')" :maxlength="10"-->
          <!--                     placeholder="请输入现金还款" label="现金还款" input-align="right"-->
          <!--                     @change="formatToTwoDecimals(item, 'payCash')"></van-field>-->

        </van-cell-group>
        <van-row v-if="!isDisabled('byjmxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加借款" @click="addImprest"
                        class="width-100"/>
          </van-col>
        </van-row>

        <van-cell-group v-f-show="'currentRepayAmountTotal'" class="m-t-20">
          <van-field v-f-show="'currentRepayAmountTotal'" center v-model="formData.currentRepayAmountTotal"
                     :rules="getRules('currentRepayAmountTotal')" :required="isRequired('currentRepayAmountTotal')"
                     label="本次冲销总金额" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.currentRepayAmountTotal)+' 元'"
                      v-if="formData.currentRepayAmountTotal && formData.currentRepayAmountTotal!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.currentRepayAmountTotal && formData.currentRepayAmountTotal!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.currentRepayAmountTotal) }}</span>
                </div>
              </div>
            </template>
          </van-field>
          <van-field v-f-show="'payCashTotal'" center v-model="formData.payCashTotal" :rules="getRules('payCashTotal')"
                     :required="isRequired('payCashTotal')" label="本次现金还款总金额" input-align="right" readonly>
            <template #input>
              <div>
                <span v-text="getFormatValue(formData.payCashTotal)+' 元'"
                      v-if="formData.payCashTotal && formData.payCashTotal!=0"></span>
                <span v-else>无</span>
                <div v-if="formData.payCashTotal && formData.payCashTotal!=0">
                  <span class="p-l-20"> 大写：</span>
                  <span class="cor-F64646">{{ getChinese(formData.payCashTotal) }}</span>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div>
        <div class="flex row-between col-center m-t-20">
          <div class="font-32 font-weight-500 cor-00 ">收款人账户信息</div>
          <van-button type="primary" :disabled="isDisabled('skryhzh')" @click="account.show = true"
                      native-type="button">选择收款人账户
          </van-button>
        </div>
        <van-cell-group class="m-t-20">
          <van-field v-f-show="'skrhm'" v-model="formData.skrhm" :disabled="isDisabled('skrhm')"
                     :required="isRequired('skrhm')" name="skrhm" :rules="getRules('skrhm')" maxlength="50" autosize
                     label="收款人户名" placeholder="请输入收款人户名" input-align="right"/>
          <van-field v-f-show="'skrkhh'" v-model="formData.skrkhh" :disabled="isDisabled('skrkhh')"
                     :required="isRequired('skrkhh')" :rules="getRules('skrkhh')" name="skrkhh" maxlength="50" autosize
                     label="收款人开户行" placeholder="请输入收款人开户行" input-align="right"/>
          <van-field v-f-show="'skryhzh'" v-model="formData.skryhzh" :disabled="isDisabled('skryhzh')"
                     :required="isRequired('skryhzh')" :rules="getRules('skryhzh')" name="skryhzh" maxlength="50"
                     autosize label="收款人账号" placeholder="请输入收款人账号" input-align="right"/>
        </van-cell-group>
      </div>
      <div v-f-show="'zffsmxb'">
        <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">财务出款</div>
        <van-cell-group v-for="(item,index) in formData.zffsmxb" :key="index" class="b-r-10 m-t-20">
          <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
            <van-row type="flex" align="center">
              <van-col :span="22">
                <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
                <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
              </van-col>
              <van-col v-if="isShowIcon('zffsmxb')" @click="removeItem(index,'zffsmxb')" :span="2">
                <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
              </van-col>
            </van-row>
          </div>
          <van-field v-f-show="'fkzh'" input-align="right" name="fkzh" :rules="getRules('fkzh')"
                     :required="isRequired('fkzh')" :value="item.fkzh" label="付款账户" placeholder="请选择付款账户">
            <template #input>
              <view-item @click.native="popupShow(fkzh.show,index,'fkzh')" :value="item.fkzh"
                         placeholder="请选择付款账户"/>
              <van-popup v-model="fkzh.show[index]" position="bottom">
                <van-nav-bar title="选择付款账户" left-text="取消" right-text="确定"
                             @click-left="popupHidden(fkzh.show,index)" @click-right="fkzhSubmit(item,index)"/>
                <van-search v-model="fkzh.filterText" @input="pickerSearch($event,fkzh,'name')" clearable
                            shape="round"/>
                <van-picker :ref="`fkzhPicker_${index}`" value-key="name" :columns="fkzh.filteredData"
                            @cancel="fkzh.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'zffs'" input-align="right" name="zffs" :rules="getRules('zffs')"
                     :required="isRequired('zffs')" :value="item.zffs" label="支付方式" placeholder="请选择支付方式">
            <template #input>
              <view-item @click.native="popupShow(zffs.show,index,'zffs')" :value="item.zffs"
                         placeholder="请选择支付方式"/>
              <van-popup v-model="zffs.show[index]" position="bottom">
                <van-nav-bar title="选择支付方式" left-text="取消" right-text="确定"
                             @click-left="popupHidden(zffs.show,index)" @click-right="zffsSubmit(item,index)"/>
                <van-search v-model="zffs.filterText" @input="pickerSearch($event,zffs,'name')" clearable
                            shape="round"/>
                <van-picker :ref="`zffsPicker_${index}`" value-key="name" :columns="zffs.filteredData"
                            @cancel="zffs.show = false"/>
              </van-popup>
            </template>
          </van-field>
          <van-field v-f-show="'zfmxje'" :disabled="isDisabled('zfmxje')" v-model="item.zfmxje" type="number"
                     name="zfmxje" :rules="getRules('zfmxje')" :required="isRequired('zfmxje')" :maxlength="10"
                     placeholder="请输入支付金额" label="支付金额" input-align="right"
                     @input="formatToTwoDecimals(item, 'zfmxje')" @change="changeZffsmxb(item)"></van-field>
        </van-cell-group>
        <van-row v-if="!isDisabled('zffsmxb')">
          <van-col :span="12"></van-col>
          <van-col :span="12">
            <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加出款明细" @click="addFKItem"
                        class="width-100"/>
          </van-col>
        </van-row>
      </div>
      <van-cell-group class="m-t-20">
        <van-field v-f-show="'sfygz'" v-model="formData.sfygz" center input-align="right"
                   :required="isRequired('sfygz')" name="sfygz" :rules="getRules('sfygz')" label="是否有挂账"
                   placeholder="是否有挂账">
          <template #input>
            <view-item v-if="isDisabled('sfygz')" :value="formData.sfygz"/>
            <van-radio-group v-else @change="changeSfgzbx()" v-model="formData.sfygz" direction="horizontal">
              <van-radio name="无">无</van-radio>
              <van-radio name="有">有</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-f-show="'gzje'" :disabled="isDisabled('gzje')" v-if="formData.sfygz==='有'" v-model="formData.gzje"
                   type="number" name="gzje" :rules="getRules('gzje')" :required="isRequired('gzje')" :maxlength="10"
                   placeholder="请输入挂账金额" label="挂账金额" input-align="right"
                   @change="formatToTwoDecimals(formData, 'gzje')"></van-field>
        <van-field v-f-show="'ckje'" :disabled="isDisabled('ckje')" v-model="formData.ckje" type="number" name="ckje"
                   :rules="getRules('ckje')" :required="isRequired('ckje')" :maxlength="10" placeholder="请输入出款金额"
                   label="出款金额" input-align="right" @input="formatToTwoDecimals(formData, 'ckje')"></van-field>
      </van-cell-group>
      <van-cell-group>
        <van-field v-f-show="'lkr'" v-model="formData.lkr" :disabled="isDisabled('lkr')" :required="isRequired('lkr')"
                   name="lkr" :rules="getRules('lkr')" label="领款人" show-word-limit placeholder="请输入领款人"
                   input-align="right"/>
        <van-field v-f-show="'lksj'" v-model="formData.lksj" :required="isRequired('lksj')" name="lksj" label="领款时间"
                   placeholder="领款时间" input-align="right" :rules="getRules('lksj')">
          <template #input>
            <view-item @click.native="isShowPopup(lksj,'lksj')" :value="formData.lksj" placeholder="请选择领款时间"/>
            <van-calendar v-model="lksj.show" :min-date="ccsj.minDate" ref="lksj" :show-confirm="false"
                          title="选择领款时间" @confirm="lksjConfirm"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'fj'" :value.prop="formData.fj" class="fileValueBox" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="fjUploadSuccess"
                         module-type="flow"   @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>

          </template>
        </van-field>
         <van-field v-f-show="'papfj'" :value.prop="formData.papfj" class="fileValueBox" input-align="right" name="papfj" :required="isRequired('papfj')"
                   :rules="getRules('papfj')" label="纸质报销凭证" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('papfj')" :files="formData.papfj" @success="uploadPapfjSuccess"
                         module-type="flow"  @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','papfj')"></uploadFiles>
          </template>
        </van-field>
        <!--        <van-field v-f-show="'fpfj'" :value.prop="formData.fpfj" input-align="right" name="fpfj" :required="isRequired('fpfj')" :rules="getRules('fpfj')" label="发票" placeholder="请上传文件">-->
        <!--          <template #input>-->
        <!--            <uploadFiles :disabled="isDisabled('fpfj')" :files="formData.fpfj" @success="fpfjUploadSuccess" module-type="flow"></uploadFiles>-->
        <!--          </template>-->
        <!--        </van-field>-->
      </van-cell-group>
      <van-row v-f-show="'fpfj'" class="m-t-20" type="flex" align="center">
        <van-col :span="12">
          <div class="font-32 font-weight-500 cor-00">发票信息</div>
        </van-col>
        <van-col :span="12">
          <van-button v-if="!isDisabled('fpfj')" icon="add-o" round native-type="button" color="#FFDA3E"
                      text="上传并识别" @click="uploadInvoice"
                      class="width-100"/>
        </van-col>
      </van-row>
      <van-cell-group v-if="formData.fpfj.length === 0" class="text-center m-t-20 p-20">
        <img class="w-300 h-300 " :src="`${image_base_url}/null.png`"></img>
        <div class="font-24 cor-8B m-t-20">暂无发票信息~</div>
      </van-cell-group>
      <van-cell-group v-f-show="'fpfj'" v-for="(item,index) in formData.fpfj" :key="index" class="b-r-10 m-t-20">
        <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
          <van-row type="flex" align="center">
            <van-col :span="22">
              <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
              <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
            </van-col>
            <van-col v-if="isShowIcon('fpfj')" @click="removeItem(index,'fpfj')" :span="2">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </van-col>
          </van-row>
        </div>
        <div v-if="item.invoiceType == 3">
          <van-field v-model="item.invoiceTitle" label="发票抬头" input-align="right" readonly/>
          <van-field v-model="item.invoiceCode" label="发票号码" input-align="right" readonly/>
          <van-field v-model="item.invoiceDate" label="开票日期" input-align="right" readonly>
            <template #input>
              {{ item.invoiceDate }}
            </template>
          </van-field>
          <van-field v-model="item.ticketPrice" label="金额" input-align="right" readonly/>
          <van-field v-model="item.travelInformation" label="行程信息" input-align="right" readonly/>
          <van-field v-model="item.travelTime" label="乘车时间" input-align="right" readonly/>
          <van-field v-model="item.passenger" label="乘车人" input-align="right" readonly/>
        </div>
          <div v-else-if="item.invoiceType == 4">
          <van-field v-model="item.invoiceTitle" label="发票抬头" input-align="right" readonly/>
          <van-field v-model="item.invoiceCode" label="发票号码" input-align="right" readonly/>
          <van-field v-model="item.invoiceDate" label="开票日期" input-align="right" readonly>
            <template #input>
              {{ item.invoiceDate }}
            </template>
          </van-field>
      
          <van-field v-model="item.ticketPrice" label="机票金额" input-align="right" readonly/>
          <van-field v-model="item.fuelFee" label="燃油附加费" input-align="right" readonly/>
          <van-field v-model="item.civilFund" label="民航发展基金" input-align="right" readonly/>
          <van-field v-model="item.invoiceAmount" label="合计金额" input-align="right" readonly/>
          <!-- <van-field v-model="item.taxAmount" label="增值税税额" input-align="right" readonly/>
          <van-field v-model="item.otherFees" label="其他税费" input-align="right" readonly/> -->
          <van-field v-model="item.departureStation" label="出发城市" input-align="right" readonly/>
          <van-field v-model="item.arriveStation" label="到达城市" input-align="right" readonly/>
          <van-field v-model="item.passenger" label="乘机人" input-align="right" readonly/>
        </div>
        <div v-else>
          <van-field v-model="item.invoiceTitle" label="发票抬头" input-align="right" readonly/>
          <van-field v-model="item.invoiceCode" label="发票号码" input-align="right" readonly/>
          <van-field v-model="item.invoiceDate" label="开票日期" input-align="right" readonly>
            <template #input>
              {{ item.invoiceDate }}
            </template>
          </van-field>
          <van-field v-model="item.taxAmount" label="税额" input-align="right" readonly/>
          <van-field v-model="item.taxExcludedAmount" label="不含税金额" input-align="right" readonly/>
          <van-field v-model="item.invoiceAmount" label="价税合计金额" input-align="right" readonly/>
        </div>
            <van-field v-f-show="'fpfj'" :value.prop="item.file.filePath" input-align="right" name="fpfj" label="附件"
                   placeholder="请上传文件">
          <template #input>
            <!-- <van-image
                width="100"
                @click="fpfjClick(item)"
                height="100"
                :src="item.file.filePath"
            /> -->
             <div v-if="item.file.filePath" class="pdfFormBox"  @click="fpfjClick(item.file)">
              <PdfPreview :ref="'PdfPreview'+index" :pdf-url="item.file.filePath" />
          </div>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group class="m-t-20">
        <van-field center v-model="invoiceAmountTotal" label="发票金额合计" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(invoiceAmountTotal)+' 元'"
                    v-if="invoiceAmountTotal && invoiceAmountTotal!=0"></span>
              <span v-else>无</span>
              <div v-if="invoiceAmountTotal && invoiceAmountTotal!=0">
                <span class="p-l-20"> 大写：</span>
                <span class="cor-F64646">{{ getChinese(invoiceAmountTotal) }}</span>
              </div>
            </div>
          </template>
        </van-field>
          <van-field v-f-show="'elecTickets'" v-model="formData.elecTickets" :disabled="isDisabled('elecTickets')" type="digit"
                   :required="isRequired('elecTickets')" :rules="getRules('pjzselecTickets')" name="elecTickets" maxlength="50" autosize
                   label="电子票据张数" @blur="pjzsChange" placeholder="请输入电子票据张数" input-align="right"/>
      <van-field v-f-show="'papTickets'" @blur="pjzsChange" v-model="formData.papTickets" :disabled="isDisabled('papTickets')" type="digit"
                   :required="isRequired('papTickets')" :rules="getRules('papTickets')" name="papTickets" maxlength="50" autosize
                   label="纸质票据张数" placeholder="请输入纸质票据张数" input-align="right"/>
          <van-field v-f-show="'pjzs'" v-model="formData.pjzs" readonly type="digit"
                    :rules="getRules('pjzs')" name="pjzs" maxlength="50" autosize
                   label="票据张数" placeholder="请输入票据张数" input-align="right"/>
      </van-cell-group>
      <div v-f-show="'relativeFlow'">
        <van-row type="flex" align="center" class="m-t-26 m-b-26">
          <van-col :span="12">
            <div class="font-32 font-weight-500 cor-00 ">关联流程</div>
          </van-col>
          <van-col v-if="formData.relativeFlow.length<=0" :span="12">
            <van-button v-if="!isDisabled('relativeFlow')" icon="add-o" round native-type="button" color="#FFDA3E"
                        text="添加审批单" @click="addSpd"
                        class="width-100"/>
          </van-col>
        </van-row>
        <van-cell-group v-if="formData.relativeFlow.length === 0" class="text-center p-20">
          <img class="w-300 h-300 " :src="`${image_base_url}/null.png`"></img>
          <div class="font-24 cor-8B m-t-20">暂无关联流程，请点击“添加审批单”关联~</div>
        </van-cell-group>
        <van-cell-group v-else v-for="(item,index) in formData.relativeFlow" :key="index" class="b-r-10 m-t-20 p-20">
          <div class="flex col-center row-between">
            <!-- 标题 -->
            <div class="flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10">
              {{ item.title }}
            </div>
            <div v-show="!isDisabled('relativeFlow')" @click="removeItem(index,'relativeFlow')"
                 class="font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </div>
          </div>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">流程状态</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.businessStatusName }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">申请时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.startTime ? moment(item.startTime).format('YYYY-MM-DD') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">完成时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.endTime ? moment(item.endTime).format('YYYY-MM-DD') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">摘要</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.summary }}
              </div>
            </van-col>
          </van-row>
        </van-cell-group>
      </div>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <van-notice-bar scrollable
                    text="流程审批须知：请务必留意，审批流程的确定需依据成本归属部门进行。即，成本归属于哪个部门，则需由该部门的相关人员进行审批。"/>

    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class=""
               :actCurrentNode="processData.actCurrentNode || ''" :flowTraceList="flowTrace"
               :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"
              :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-35">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
    <relativeFlow :show="relativeFlow.show" groupId="11" @finish="relativeFlowFinish"
                  @close="relativeFlow.show = false"></relativeFlow>
    <account :show="account.show" @finish="accountFinish" @close="account.show = false"></account>
    <imprest :show="imprest.show" @finish="imprestFinish" @close="imprest.show = false"></imprest>
    <invoice ref="invoice" @close="invoiceClose" @success="invoiceSuccess" :show="invoice.show"></invoice>
      <van-popup v-model="PdfPreviewShow" style="max-height:70%;overflow: auto; width: calc(100% - 20px);">
      <PdfPreview ref="PdfPreviewPop" :pdf-url="PdfPreviewPopFilePath"/>
      </van-popup>
  </div>
</template>
<script>
import PdfPreview from '@/components/PdfPreview/index.vue'; // 引入上述组件
import mixin from '@/mixin/flow'
import cache from "@/plugins/cache";
import moment from "moment";
import {
  getFormDataByInstanceId,
  getRelaveFormDataByInstanceId,
  getRemoteData,
  getSubjectTree,
  listContractAndProject,
  selectProjectDept
} from '@/api/flow'
import {getCurrentUserDept, getDeptUserTreeAll} from '@/api/user.js'
import {getAccountList, getCategoryTree} from '@/api/reimbursement.js'
import {queryFmAccount} from '@/api/account'
import {getDictDataByType, provinceTree} from "@/api/dict";
import {getUserPayCompany} from '@/api/hrm/index';
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import relativeFlow from '@/components/flow/relativeFlow.vue'
import account from '@/views/tripReimbursement/components/account.vue'
import contract from "@/views/reimbursement/components/contract.vue";
import imprest from '@/components/flow/imprest.vue'
import invoice from '@/components/flow/invoice.vue'
import {formatToTwoDecimals} from "@/utils/ruoyi";
import {Toast} from 'vant';

const jdItem = {
  // 报销金额
  bxje: null,
  // 出差城市
  cccs: '',
  // 是否合住
  sfhz: '',
  // 入住日期
  rzrq: '',
  // 离店日期
  ldrq: '',
  // 天数
  zsts: null,
  gskm: ''
}
const cjjtItem = {
  xch: '',
  cfsj: '',
  cfcs: '',
  ddcs: '',
  jtgj: '',
  jtlksj: '',
  jtfyje: '',
  jtfysm: '',
  jtfygskm: '',
}
const qtfyItem = {
  qtfyje: null,
  qtfylx: "",
  qtfymx: "",
  qtgskm: ''
}
const clbzItem = {
  cbbz: 60,
  cbts: 0,
  cbje: 0,
  clgskm: '',
  ccsj: []
}
const zfItem = {
  // 支付方式
  zffs: "",
  // 付款账户
  fkzh: "",
  // 支付金额
  zfmxje: ""
}
export default {
  mixins: [mixin,fileMixins],
  components: {invoice, uploadFiles, bottomBar, approver, flowTrace, relativeFlow, account, contract, imprest,PdfPreview},
  data() {
    const _this = this

    return {
      PdfPreviewShow: false,
      PdfPreviewPopFilePath: '',
      moment,
      travelAllowanceConfig: {type: 1, standard: 60},
      deptcost: '',
      imprest: {
        show: false
      },
      // 发票识别
      invoice: {
        show: false
      },
      btnLoading: false,
      currentUserInfo: {},
      formData: {
        // 本次冲销总金额
        currentRepayAmountTotal: 0,
        // 申请时间
        startFlowDate: moment().format('YYYY-MM-DD'),
        flowNo: '',
        // 所有费用加起来
        bxzje: 0,
        // 酒店住宿费用合计
        jdzsfhj: 0,
        // 城际交通费用合计
        cjjtfhj: 0,
        // 其他费用合计
        qtfyhj: 0,
        // 差旅补助合计
        clbzhj: 0,
        // 出款金额
        ckje: 0,
        sqr: '',
        pjzs: 0,
        elecTickets:0,
        papTickets:'',
        // 核算公司
        hsgs: '',
        lkr: '',
        lksj: '',
        skrbz: '',
        ssbm: '',
        debtMoney: '',
        bxfs: '0',
        bxsy: '',
        skrfkbz: '报销款',
        ssxm: '',
        sfygz: '无',
        relativeFlow: [],
        fj: [],
        papfj:[],
        fpfj: [],
        // 备用金明细表
        byjmxb: [],
        // 本次冲销总金额
        currentRepayAmount: 0,
        // 现金还款总金额
        payCashTotal: 0,
        // 出款明细
        zffsmxb: [{
          // 支付方式
          zffs: "",
          // 付款账户
          fkzh: "",
          // 支付金额
          zfmxje: ""
        }],
        jdzsfymxb: [{
          // 报销金额
          bxje: null,
          // 出差城市
          cccs: '',
          // 是否合住
          sfhz: '',
          // 入住日期
          rzrq: '',
          // 离店日期
          ldrq: '',
          // 天数
          zsts: null,
          gskm: ''
        }],
        cjjtfymxb: [{
          xch: '',
          cfsj: '',
          cfcs: '',
          ddcs: '',
          jtgj: '',
          jtlksj: '',
          jtfyje: '',
          jtfysm: '',
          jtfygskm: '',
        }],
        qtfymxb: [{
          qtfyje: null,
          qtfylx: "",
          qtfymx: "",
          qtgskm: ''
        }],
        clbzmxb: [{
          cbbz: 60,
          cbts: 0,
          cbje: 0,
          ccsj: [],
          clgskm: ''
        }],
        zmlx: ['管理账套', '核算账套'],
      },
      contract: {
        show: false,
      },
      invoiceAmountTotal: 0,
      qtfylx: {
        data: [],
        show: [],
        filterText: [],
      },
      sfhz: {
        data: ['是', '否'],
        show: [],
        filteredData: ['是', '否'],
        filterText: '',
      },
      ldrq: {
        show: []
      },
      cfsj: {
        show: []
      },
      jtlksj: {
        show: []
      },
      ccsj: {
        show: [],
        minDate: new Date(2020, 0, 1),
      },
      lksj: {
        show: false
      },
      cccs: {
        data: [],
        show: [],
        filterText: [],
      },
      cfcs: {
        data: [],
        show: [],
        filterText: [],
      },
      ddcs: {
        data: [],
        show: [],
        filterText: [],
      },
      // 报销类型树
      tategoryTree: {
        data: []
      },
      account: {
        show: false,
      },
      // 账户树
      accountList: {
        data: []
      },
      // 付款账户
      fkzh: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      zffs: {
        data: [{name: '现金'}, {name: '对公'}, {name: '其他'}],
        show: [],
        filteredData: [{name: '现金'}, {name: '对公'}, {name: '其他'}],
        filterText: '',
      },

      // 关联流程
      relativeFlow: {
        show: false
      },
      rzrq: {
        show: []
      },
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      startFlowDate: {
        show: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2030, 0, 1)
      },
      hsgs: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 交通工具字典
      jtgj: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      gskm: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      // 账目类型
      zmlx: {
        data: ["管理账套", "核算账套"],
        show: false,
        filteredData: ["管理账套", "核算账套"],
        filterText: '',
      },
      jtfygskm: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      qtgskm: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      clgskm: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      // 自定义校验数据
      rules: {
        currentRepayAmountTotal: [
          {
            validator: () => {
              return Number(_this.formData.currentRepayAmountTotal) <= Number(_this.formData.bxzje)
            }, message: '本次借款冲销总金额不能大于报销总金额'
          }
        ],
      },
      formItemMap: null, // 表单字段的Map
    }
  },
  watch: {
    'formData.fpfj': {
      handler(val) {
        this.calBillCount();
      },
      deep: true
    },
    'formData.byjmxb': {
      handler(val) {
        // 计算总金额
        this.formData.currentRepayAmountTotal = this.formData.byjmxb.reduce((pre, cur) => {
          return pre + Number(cur.currentRepayAmount)
        }, 0)
        this.formData.payCashTotal = this.formData.byjmxb.reduce((pre, cur) => {
          return pre + Number(cur.payCash)
        }, 0)
      },
      deep: true
    },
    'formData.jdzsfymxb': {
      handler: function (val) {
        this.formData.jdzsfhj = val.reduce((total, item) => {
          return total + (item.bxje * 1 || 0)
        }, 0)
        const bxzje = this.formData.jdzsfhj * 1 + this.formData.cjjtfhj * 1 + this.formData.qtfyhj * 1 + this.formData.clbzhj * 1
        this.formData.bxzje = bxzje.toFixed(2)
        this.formData.ckje = bxzje.toFixed(2)
      },
      deep: true
    },
    'formData.cjjtfymxb': {
      handler: function (val) {
        this.formData.cjjtfhj = val.reduce((total, item) => {
          return total + (item.jtfyje * 1 || 0)
        }, 0)
        const bxzje = this.formData.jdzsfhj * 1 + this.formData.cjjtfhj * 1 + this.formData.qtfyhj * 1 + this.formData.clbzhj * 1
        this.formData.bxzje = bxzje.toFixed(2)
        this.formData.ckje = bxzje.toFixed(2)
      },
      deep: true
    },
    'formData.qtfymxb': {
      handler: function (val) {
        this.formData.qtfyhj = val.reduce((total, item) => {
          return total + (item.qtfyje * 1 || 0)
        }, 0)
        const bxzje = this.formData.jdzsfhj * 1 + this.formData.cjjtfhj * 1 + this.formData.qtfyhj * 1 + this.formData.clbzhj * 1
        this.formData.bxzje = bxzje.toFixed(2)
        this.formData.ckje = bxzje.toFixed(2)
      },
      deep: true
    },
    'formData.clbzmxb': {
      handler: function (val) {
        // 使用 Number() 和 || 0 确保数值计算的准确性
        this.formData.clbzhj = val.reduce((total, item) => {
          return total + (Number(item.cbje) || 0)
        }, 0)
        // 确保所有费用项都是数值类型后再计算
        const bxzje = Number(this.formData.jdzsfhj) +
            Number(this.formData.cjjtfhj) +
            Number(this.formData.qtfyhj) +
            Number(this.formData.clbzhj)

        // 使用 parseFloat 和 toFixed 确保精度
        this.formData.bxzje = parseFloat(bxzje).toFixed(2)
        this.formData.ckje = parseFloat(bxzje).toFixed(2)
      },
      deep: true
    },
    'formData.ckje': {
      handler(val) {
        this.changeZffsmxb();
      },
    },
    'formData.bxzje': {
      handler(val) {
        if (this.formData.sfygz === '无') { // 出款金额等于报销总金额
          this.formData.ckje = val
        } else {// 出款金额等于报销总金额 - 挂账金额
          this.formData.ckje = val - this.formData.gzje
        }
      },
    },
    'formData.gzje': {
      handler(val) {
        if (this.formData.sfygz === '无') { // 出款金额等于报销总金额
          this.formData.ckje = this.formData.bxzje
        } else {// 出款金额等于报销总金额 - 挂账金额
          this.formData.ckje = this.formData.bxzje - val
        }
      },
    },
  },
  created() {
    const _this = this
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        this.travelAllowanceConfig = res.data.travelAllowanceConfig
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          // form.data.papTickets=form.data.papTickets?form.data.papTickets:0
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
        if (_this.formData.ssxm) {
          selectProjectDept({
            id: _this.formData.ssxm.split(',')[0],
            type: _this.formData.ssxm.split(',')[2] ? _this.formData.ssxm.split(',')[2] : 1
          }).then(res => {
            _this.deptcost = res.data.unitName
          })
        }
          this.calBillCount()
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) {
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        this.$nextTick(() => {
          // res.data.formData.papTickets=res.data.formData.papTickets?res.data.formData.papTickets:0
          Object.assign(this.formData, res.data.formData);
          if (_this.formData.ssxm) {
          selectProjectDept({
            id: _this.formData.ssxm.split(',')[0],
            type: _this.formData.ssxm.split(',')[2] ? _this.formData.ssxm.split(',')[2] : 1
          }).then(res => {
            _this.deptcost = res.data.unitName
          })
        }
          this.calBillCount()
        });
        this.travelAllowanceConfig = res.data.travelAllowanceConfig
        if (res.data.formData.hsgs) {
          let belongUnit = res.data.formData.hsgs.split(',')[0]
          // 获取付款账户
          this.queryFmAccount({belongUnit})
        }

        //关联出差申请相同日期内多次报销消息提示
        let warningMessage = res.data.warningMessage
        if (warningMessage) {
          this.$notify({type: 'warning', message: warningMessage, duration: 5000});
        }
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时候直接调用获取本人欠款
      this.getUserDebt()
      // 新增时调用
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        this.travelAllowanceConfig = res.data.travelAllowanceConfig
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 关联流程跳转时
      if (this.$route.query.isRelevanceFlow) {
        const params = {
          processInstanceId: this.$route.query.destProcessInstanceId,
          destGroupId: this.$route.query.groupId
        }
        getRelaveFormDataByInstanceId(params).then(res => {
          Object.assign(this.formData, res.data)
        })
      }
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.currentUserInfo = currentUserInfo
      this.formData.lkr = currentUserInfo.nickName
      this.selectMyProjectList(currentUserInfo)
      this.getCurrentUserDept(currentUserInfo)
      // 获取付款账户
      this.queryFmAccount()
      this.relativeFlow.show = true
    }
  },
  methods: {
    formatToTwoDecimals,
    // 进页面就调用
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 账户
      this.getAccountList()
      // 归属科目
      this.getSubject()
      // 省市树
      this.getProvinceTree()
      // 核算公司
      this.getUserPayCompany()
      // 报销类型
      this.getCategoryTree()
      // 交通工具 trafic_type
      getDictDataByType('trafic_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.jtgj.data = data
        this.jtgj.filteredData = data
      })
    },

    // 图片预览
    fpfjClick(item) {
       this.PdfPreviewShow=true
      this.PdfPreviewPopFilePath=item.filePath
      this.$nextTick(()=>{
        this.$refs['PdfPreviewPop'].initPdfjs(item.filePath)
        this.$refs['PdfPreviewPop'].resetPDF()
        this.$refs['PdfPreviewPop'].loadPDF(item.filePath)
      })
    },
    pjzsChange() {
      const elecTickets = parseFloat(this.formData.elecTickets) || 0;
      const papTickets = parseFloat(this.formData.papTickets) || 0;
      const totalTickets = elecTickets + papTickets;
      // 更新pjzs字段
      this.$set(this.formData, 'pjzs', totalTickets);
    },
    calBillCount() {
      if (this.formData.fpfj) {
        let total = 0
        for (let i = 0; i < this.formData.fpfj.length; i++) {
          total = total + parseFloat(this.formData.fpfj[i].invoiceAmount ? this.formData.fpfj[i].invoiceAmount : this.formData.fpfj[i].ticketPrice)
        }
        this.$set(this.formData, 'elecTickets', this.formData.fpfj.length);
        this.pjzsChange()
        this.invoiceAmountTotal = parseFloat(parseFloat(total).toFixed(2))
      }
    },
    getProvinceTree() {
      provinceTree().then(res => {
        this.cccs.data = res.data
        this.cfcs.data = res.data
        this.ddcs.data = res.data
      })
    },
    // 备用金添加
    addImprest() {
      this.imprest.show = true;
    },
// 修改是否挂账报销
    changeSfgzbx() {
      if (this.formData.sfgzbx === "否") {
        // 不使用挂账报销时，收款人姓名、收款人开户行、收款人账号都必填，且显示
        this.changeItemShow("skrhm", "E");
        this.changeItemShow("skrkhh", "E");
        this.changeItemShow("skryhzh", "E");
        this.changeItemShow("bxfs", "E");

        this.changeItemRequire("skrhm", true);
        this.changeItemRequire("skrkhh", true);
        this.changeItemRequire("skryhzh", true);
        this.changeItemRequire("bxfs", true);

        this.formData.sfygz = '无';

      } else {
        // 使用挂账报销时，收款人开户行、收款人账号都非必填，且不显示
        this.changeItemShow("skrhm", "E");
        this.changeItemShow("skrkhh", "H");
        this.changeItemShow("skryhzh", "H");
        this.changeItemShow("bxfs", "H");

        this.changeItemRequire("skrhm", false);
        this.changeItemRequire("skrkhh", false);
        this.changeItemRequire("skryhzh", false);
        this.changeItemRequire("bxfs", false);

        this.formData.sfygz = '有';
      }
      // this.changeCkzjeByGzbx()
    },
    // 修改修改报销方式
    changeBxfs() {
      if (this.formData.bxfs === "1") {
        this.imprest.show = true
      }
      if (this.formData.bxfs === "2") {
        this.changeItemRequire("skrhm", false);
        this.changeItemRequire("skrkhh", false);
        this.changeItemRequire("skryhzh", false);
      } else {
        this.changeItemRequire("skrhm", true);
        this.changeItemRequire("skrkhh", true);
        this.changeItemRequire("skryhzh", true);
      }
    },
    // 备用金选框
    imprestFinish(list) {
      // 根据id对比list和formData.byjmxb，如果list中有formData.byjmxb没有的，添加到formData.byjmxb
      list.forEach(item => {
        if (!this.formData.byjmxb.find(ele => ele.id === item.id)) {
          this.formData.byjmxb.push(item)
        }
      })
      this.imprest.show = false;
    },
    sfhzSubmit(item, index) {
      let sfhz = this.$refs[`sfhzPicker_${index}`][0].getValues()[0];
      this.$set(item, 'sfhz', sfhz);
      this.popupHidden(this.sfhz.show, index)
    },
    cccsPopupSubmit(item, index) {
      let cccs = this.$refs[`cccsTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.$set(item, 'cccs', cccs);
      this.popupHidden(this.cccs.show, index)
    },
    cfcsPopupSubmit(item, index) {
      let cfcs = this.$refs[`cfcsTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.$set(item, 'cfcs', cfcs);
      this.popupHidden(this.cfcs.show, index)
    },
    ddcsPopupSubmit(item, index) {
      let ddcs = this.$refs[`ddcsTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.$set(item, 'ddcs', ddcs);
      this.popupHidden(this.ddcs.show, index)
    },
    jtgjSubmit(item, index) {
      let jtgj = this.$refs[`jtgjPicker_${index}`][0].getValues()[0];
      this.$set(item, 'jtgj', jtgj);
      this.popupHidden(this.jtgj.show, index)
    },
    fkzhSubmit(item, index) {
      let fkzh = this.$refs[`fkzhPicker_${index}`][0].getValues()[0].id + ',' + this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name;
      this.$set(item, 'fkzh', fkzh);
      if (this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name.includes('基本户') || this.$refs[`fkzhPicker_${index}`][0].getValues()[0].name.includes('一般户')) {
        this.$set(item, 'zffs', '对公');
      } else {
        this.$set(item, 'zffs', '现金');
      }
      this.popupHidden(this.fkzh.show, index)
    },
    zffsSubmit(item, index) {
      let zffs = this.$refs[`zffsPicker_${index}`][0].getValues()[0].name;
      this.$set(item, 'zffs', zffs);
      this.popupHidden(this.zffs.show, index)
    },
    // 添加审批单
    addSpd() {
      this.relativeFlow.show = true
    },
    ccsjConfirm(date, item, index) {
      item.ccsj = date.map(single => {
        return moment(single).format('YYYY-MM-DD')
      })
      let day = this.dayLength(item.ccsj[1], item.ccsj[0])
      let type = 1
      if (this.travelAllowanceConfig) {
        console.log(this.travelAllowanceConfig, 'this.travelAllowanceConfigthis.travelAllowanceConfig')
        type = this.travelAllowanceConfig.type
      }
      if (type == 1) {
        day = day + 1
      }
      if (type == 3) {
        day = 0;
      }

      this.ccsj.show[index] = false
      // item.cbts = moment(date[1]).diff(date[0], 'days')
      item.cbts = day
      item.cbje = this.calTravelExpense(parseFloat(item.cbts), parseFloat(item.cbbz));
    },
    dayLength(end, start) {
      let days = moment(end).diff(moment(start), 'days');
      console.log(days);
      return days
    },
    calTravelExpense(day, money) {
      let type = 1
      if (this.travelAllowanceConfig) {
        type = this.travelAllowanceConfig.type
      }
      if (type == 3) {
        return 0;
      }
      return money * day === 0 ? 0 : (money * day).toFixed(2)
    },
    cbbzFieldInput(value, item, index) {
      // 更严格的判断，处理 null、undefined、空字符串等情况
      const cbts = parseFloat(item.cbts);
      const cbbz = parseFloat(value);
      if (Number(cbts) > 0 && Number(cbbz) > 0 && this.travelAllowanceConfig.type != 3) {
        // 使用 $set 确保响应式更新
        this.$set(item, 'cbje', this.calTravelExpense(cbts, cbbz));
      }
    },
    hasOverlap(start1, end1, start2, end2, includeEnd) {
      if (includeEnd) {
        return !(end1.isBefore(start2) || start1.isAfter(end2));
      }
      return !(end1.isBefore(start2) || start1.isAfter(end2) || end1.isSame(start2));
    },
    validateOverLap() {
      let type = 1
      if (this.travelAllowanceConfig) {
        type = this.travelAllowanceConfig.type
      }
      if (type == 3) {
        return true
      }
      let includeEnd = true
      if (type == 2) {
        includeEnd = false
      }
      let arr = this.formData.clbzmxb;
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (!(arr[i] && arr[i].ccsj[0] && arr[i].ccsj[1])) {
            continue;
          }
          let start1 = moment(arr[i].ccsj[0]);
          let end1 = moment(arr[i].ccsj[1]);
          for (let j = i + 1; j < arr.length; j++) {
            if (!(arr[j] && arr[j].ccsj[0] && arr[j].ccsj[1])) {
              continue;
            }
            let start2 = moment(arr[j].ccsj[0]);
            let end2 = moment(arr[j].ccsj[1]);
            if (this.hasOverlap(start1, end1, start2, end2, includeEnd)) {
              this.$notify({
                type: 'warning',
                message: '差旅补助出差时间：' + arr[i].ccsj[0] + "~" + arr[i].ccsj[1] + '和' + arr[j].ccsj[0] + "~" + arr[j].ccsj[1] + '日期重叠，请重新调整'
              });
              return false
            }
          }
        }
      }
      return true;
    },
    rzrqConfirm(date, item, index) {
      // 入住日期不能大于离店日期
      if (item.ldrq && moment(date).isAfter(item.ldrq)) {
        return this.$toast('入住日期不能大于离店日期')
      }
      this.$set(this.rzrq.show, index, false);
      item.rzrq = moment(date).format('YYYY-MM-DD')
      // 自动计算天数
      if (item.ldrq) {
        item.zsts = moment(item.ldrq).diff(moment(item.rzrq), 'days')
      }
    },
    // 发票识别并上传
    uploadInvoice() {
      this.invoice.show = true
      this.$nextTick(()=>{
        this.$refs['invoice'].clearForm()
      })
    },
    invoiceClose() {
      this.invoice.show = false;
    },
    // 发票上传完成回调
    invoiceSuccess(data) {
          console.log(data)
      this.formData.fpfj.push(data)
      let index=this.formData.fpfj.length-1
      this.$nextTick(()=>{
        console.log(this.$refs['PdfPreview'+index])
         this.$refs['PdfPreview'+index][0].initPdfjs(data.filePath)
        this.$refs['PdfPreview'+index][0].resetPDF()
         this.$refs['PdfPreview'+index][0].loadPDF(data.filePath)
      
      })
      this.invoice.show = false
    },
    lksjConfirm(date) {
      this.formData.lksj = moment(date).format('YYYY-MM-DD')
      this.lksj.show = false
    },
    ldrqConfirm(date, item, index) {
      // 离店日期不能小于入住日期
      if (item.rzrq && moment(date).isBefore(item.rzrq)) {
        return this.$toast('离店日期不能小于入住日期')
      }
      this.$set(this.ldrq.show, index, false);
      item.ldrq = moment(date).format('YYYY-MM-DD')
      // 自动计算天数
      if (item.rzrq) {
        item.zsts = moment(item.ldrq).diff(moment(item.rzrq), 'days')
      }
    },
    cfsjConfirm(date, item, index) {
      // 出发时间不能大于离开时间
      if (item.jtlksj && moment(date).isAfter(item.jtlksj)) {
        return this.$toast('出发时间不能大于离开时间')
      }
      this.$set(this.cfsj.show, index, false);
      item.cfsj = moment(date).format('YYYY-MM-DD')
    },
    // 显示合同选择框
    showContract() {
      if (!this.isDisabled('ssxm')) {
        this.contract.show = true
        this.$refs['contractSelect'].init()
      }
    },
    startFlowDateConfirm(date) {
      this.formData.startFlowDate = moment(date).format('YYYY-MM-DD')
      this.startFlowDate.show = false
    },
    jtlksjConfirm(date, item, index) {
      // 离开时间不能小于出发时间
      if (item.cfsj && moment(date).isBefore(item.cfsj)) {
        return this.$toast('离开时间不能小于出发时间')
      }
      this.$set(this.jtlksj.show, index, false);
      item.jtlksj = moment(date).format('YYYY-MM-DD')
    },
    gskmSubmit(item, index) {
      item.gskm = this.$refs[`gskmTree_${index}`][0].getCheckedNodes()[0].id;
      this.popupHidden(this.gskm.show, index)
    },
    jtfygskmSubmit(item, index) {
      item.jtfygskm = this.$refs[`jtfygskmTree_${index}`][0].getCheckedNodes()[0].id;
      this.popupHidden(this.jtfygskm.show, index)
    },
    clgskmSubmit(item, index) {
      item.clgskm = this.$refs[`clgskmTree_${index}`][0].getCheckedNodes()[0].id;
      this.popupHidden(this.clgskm.show, index)
    },
    qtgskmSubmit(item, index) {
      item.qtgskm = this.$refs[`qtgskmTree_${index}`][0].getCheckedNodes()[0].id;
      this.popupHidden(this.qtgskm.show, index)
    },
    // 报销类型树
    getCategoryTree() {
      getCategoryTree().then(res => {
        const data = this._getCategoryTree(res.data)
        this.$set(this.qtfylx, 'data', data)
      })
    },
    addJdItem() {
      this.formData.jdzsfymxb.push(JSON.parse(JSON.stringify(jdItem)))
    },
    addcjjtItem() {
      this.formData.cjjtfymxb.push(JSON.parse(JSON.stringify(cjjtItem)))
    },
    addQtfyItem() {
      this.formData.qtfymxb.push(JSON.parse(JSON.stringify(qtfyItem)))
    },
    addClbzItem() {
      let standard = 60
      if (this.travelAllowanceConfig) {
        standard = this.travelAllowanceConfig.standard
      }
      let row = {...clbzItem, "cbbz": standard}
      this.formData.clbzmxb.push(JSON.parse(JSON.stringify(row)))
    },
    addFKItem() {
      this.formData.zffsmxb.push(JSON.parse(JSON.stringify(zfItem)));
      let belongUnit = this.formData.hsgs.split(',')[0]
      // 获取付款账户
      this.queryFmAccount({belongUnit})
      this.changeZffsmxb();
    },
    relativeFlowFinish(data) {
      const params = {
        processInstanceId: data[0].processInstanceId,
        destGroupId: 5
      }
      getRelaveFormDataByInstanceId(params).then(res => {
        this.formData.bxsy = res.data.bxsy
        this.formData.cjjtfymxb = res.data.cjjtfymxb
        this.formData.clbzmxb = res.data.clbzmxb.map(item => {
          return {
            // cbts: moment(item.ccsj[1]).diff(item.ccsj[0], "days"),
            cbts: this.cbtsFormula(item),
            cbje: this.calTravelExpense(Number(item.cbbz), this.cbtsFormula(item)),
            ...item
          }
        })
      })
      this.formData.relativeFlow = data
      this.relativeFlow.show = false
    },
    cbtsFormula(item) {
      let day = this.dayLength(item.ccsj[1], item.ccsj[0])
      let type = 1
      if (this.travelAllowanceConfig) {
        type = this.travelAllowanceConfig.type
      }
      if (type == 1) {
        day = day + 1
      }
      if (type == 3) {
        day = 0;
      }
      return day
    },
    qtfylxPopupSubmit(item, index) {
      if (this.$refs[`qtfylxTree_${index}`][0].getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一项', position: 'bottom'})
        return
      }
      item.qtfylx = this.$refs[`qtfylxTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.popupHidden(this.qtfylx.show, index)
    },
    // 收款人账户信息
    accountFinish(select) {
      this.formData.skrhm = select[0].accountName
      this.formData.skrkhh = select[0].accountBank
      this.formData.skryhzh = select[0].accountNo
      this.account.show = false
    },
    removeItem(index, field) {

      if (field == 'cjjtfymxb' && this.formData[field].length === 1 && field !== 'relativeFlow') {
        return this.$toast('请至少保留一项')
      }

      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
        if (field === 'zffsmxb') {
          this.changeZffsmxb()
        }
      })
    },
    // 核算公司
    getUserPayCompany() {
      getUserPayCompany().then(res => {
        this.hsgs.data = res.data
        this.hsgs.filteredData = res.data
        if (res.data.length > 0 && (!this.$route.query.processInstanceId)) {
          res.data.forEach(item => {
            if (item.selFlag == '1') {
              this.formData.hsgs = item.id + "," + item.name
            }
          })
        }
      })
    },
    // 归属科目
    getSubject() {
      getSubjectTree().then(res => {
        const data = this._getCategoryTree(res.data)
        this.gskm.data = data
        this.gskm.filteredData = data
        this.jtfygskm.data = data
        this.jtfygskm.filteredData = data
        this.qtgskm.data = data
        this.qtgskm.filteredData = data
        this.clgskm.data = data
        this.clgskm.filteredData = data
      })
    },
    _getCategoryTree(treeList) {
      // 使用箭头函数来保持对 Vue 组件实例的 this 的引用
      const processTree = (originalItems) => {
        const newItems = []; // 创建一个新数组来存储处理过的节点
        originalItems.forEach(item => {
          const newItem = {...item}; // 创建一个新对象来避免修改原始数据
          newItem.disabled = newItem.children ? true : false;
          newItem.uuid = this.uuid(); // 确保正确访问 Vue 组件实例的方法
          if (newItem.children && newItem.children.length > 0) {
            newItem.children = processTree(newItem.children); // 递归调用并更新 children
          }
          newItems.push(newItem); // 将处理过的节点添加到新数组中
        });
        return newItems; // 返回新数组
      };
      return processTree(treeList); // 启动递归处理并返回新的树列表
    },
    // 获取用户欠款
    getUserDebt(userId) {
      let url = '/payment/debt/selfDebt?userId='
      if (userId) {
        url = url + userId
      }
      getRemoteData(url, 'get', {}).then(response => {
        if (response.data) {
          this.formData.debtMoney = response.data.debt
        }
      });
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          // 搜索过滤
          this.ssbm.filteredData = this.ssbm.data
          resolve(res.data)
        })
      })
    },
    businessSelectFinish(field) {
      const item = this.$refs[field].getValues()[0]
      selectProjectDept({id: item.id, type: item.typeValue}).then(res => {
        this.deptcost = res.data.unitName
      })
      this.$set(this.formData, 'ssxm', item.id + "," + item.name + "," + item.typeValue)
      this.$set(this[field], 'show', false)
      // this.$set(this.formData, field, item[props.value] + ',' + item[props.label])
    },
    onChange(picker, value, index) {
      Toast(`当前选项类型为：${value.type}，${value.name}`);
    },
    // 获取人员所属项目列表
    selectMyProjectList(user, more) {
      this.btnLoading = true

      const params = {
        userId: user.id || user.userId,
        more
      }
      return new Promise((resolve) => {
        listContractAndProject(params).then(res => {
          this.btnLoading = false
          this.ssxm.data = res.data
          this.ssxm.filteredData = res.data.map(item => ({
            ...item,
            columnsLabel: `${item.type}-${item.name}`
          }))
          resolve(res.data)
        })
      })
    },
    getAccountList() {
      return new Promise(resolve => {
        const params = {
          delFlag: 0
        }
        getAccountList(params).then(res => {
          this.accountList.data = res.data;
        })
      })
    },

    fjUploadSuccess(fileList) {
      this.formData.fj = fileList
    },
    uploadPapfjSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.papfj = fileList
    },
    fpfjUploadSuccess(fileList) {
      this.formData.fpfj = fileList
    },
    // 修改出款明细
    changeZffsmxb(eItem) {
      let ckjeTotal = JSON.parse(JSON.stringify(this.formData.ckje))
      let zfjeTotal = 0;
      this.formData.zffsmxb.map(item => {
        item.zfmxje = Number(item.zfmxje)
        zfjeTotal = zfjeTotal + item.zfmxje;
      })
      // 计算需要补上的数额
      let cha = ckjeTotal - zfjeTotal;

      this.formData.zffsmxb.map(item => {
        if (eItem != item) {
          if (cha == 0) {
            return;
          }
          let itemResult = item.zfmxje + cha;
          if (itemResult > 0) {
            item.zfmxje = item.zfmxje + cha;
            cha = 0;
          } else {
            item.zfmxje = item.zfmxje + (cha - itemResult)
            cha = cha - (cha - itemResult)
          }
        }
      })
      if (cha < 0) {
        Toast.fail("支付金额大于出账金额，请检查")
      }
      this.changeCkzjeByGzbx()
    },
    // 如果是挂账报销 挂账报销金额等于出款总金额，出款金额为0
    changeCkzjeByGzbx() {
      if (this.formData.sfygz === "是") {
        this.formData.gzje = this.formData.bxzje
        this.formData.ckje = 0;
      }
    },
    queryFmAccount(query) {
      queryFmAccount(query).then(res => {
        this.fkzh.data = res.data
        this.fkzh.filteredData = res.data
      })

    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
  }
}
</script>
